import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputMask, InputMaskChangeParams } from 'primereact/inputmask';

import { ModelOfBidding, ModelOfFatura } from 'src/database';

import useIntersectionObserver from 'src/components/IntersectionObserver/useIntersectionObserver';
import LoadingScreen from '../../components/LoadingScreen';
import { useListFaturasController, } from '../../controllers/Fatura/ListFaturasController';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';
import { PulseLoader } from 'react-spinners';
import { Divider } from 'primereact/divider';
import { InputNumber } from 'primereact/inputnumber';
import { AutoComplete } from 'primereact/autocomplete';
import { dateToString } from 'src/utils/dateToString';
import { Tooltip } from 'primereact/tooltip';

interface InputMaskProps {
    label: string;
    mask: string;
    placeholder: string;
}

interface filteredProps {
    label: string;
    value?: string;
}

const FaturasList: React.FC = () => {
    const { getFaturaListController, handleFaturaListController } = useListFaturasController();
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);

    if (getFaturaListController.loading) {
        return <LoadingScreen />
    };


    const tableHeader = (
        <div className="table-header p-grid p-d-flex p-jc-between">
            <h5 className="p-m-0">Faturas</h5>
            <span className="p-input-icon-left p-search-bar">
                <i className="pi pi-search" />
                <InputText type="search" onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>
        </div>
    );

    const actionBodyTemplate = (Fatura: ModelOfFatura) => {
        return (

            <React.Fragment>
                <Tooltip target=".unity-editarnegocio-btn" content="Editar negocio" position="top" />
                <Tooltip target=".unity-excluirnegocio-btn" content="Excluir negocio" position="top" />
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success p-mr-2 unity-editarnegocio-btn" onClick={() => handleFaturaListController.openEditDialog(Fatura)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger unity-excluirnegocio-btn" onClick={() => handleFaturaListController.openDeleteDialog(Fatura)} />
                <Button icon="pi pi-print" className="p-button-rounded p-button-text p-button-info unity-printfatura-btn" onClick={() => handleFaturaListController.openPrintDialog(Fatura)} />

            </React.Fragment>
        );
    };

    const editFaturaDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleFaturaListController.closeEditDialog} />
            <Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getFaturaListController.formik.handleSubmit() }} />
        </React.Fragment>
    );



    const deleteFaturaDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleFaturaListController.closeDeleteDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text"
                onClick={() => {
                    getFaturaListController.selectedFatura && handleFaturaListController.removeFatura(getFaturaListController.selectedFatura)
                }}
            />
        </React.Fragment>
    );

    const leftFaturaToolbar = () => {
        return (
            <Link to="/negocioForm">
                <Button label="Cadastrar negocio" icon="pi pi-plus" className="p-button-success p-mr-2" />
            </Link>
        );
    };

    const HEADER_NUMERO = (rowData: ModelOfFatura) => {
        return (
            <React.Fragment>
                <span className="left-header">NÚMERO</span>
                {rowData.NUMERO}
            </React.Fragment>
        );
    }
    const HEADER_DESCRICAO = (rowData: ModelOfFatura) => {
        return (
            <React.Fragment>
                <span className="left-header">DESCRICAO</span>
                {rowData.FT_CONTRATO.DESCRICAO}
            </React.Fragment>
        );
    }

    const HEADER_ORGAOUNIDADE = (rowData: ModelOfFatura) => {
        return (
            <React.Fragment>
                <span className="left-header">ORGAOUNIDADE</span>
                {rowData.ORGAOUNIDADE ? rowData.ORGAOUNIDADE : "Não informado"}
            </React.Fragment>
        );
    }

    const HEADER_NEGOCIO = (rowData: ModelOfFatura) => {
        return (
            <React.Fragment>
                <span className="left-header">NEGOCIO</span>
                {rowData.FT_NEGOCIO.RAZAOSOCIAL}
            </React.Fragment>
        );
    }

    const HEADER_DATA = (rowData: ModelOfFatura) => {
        const formatDate = (dateString: string | undefined) => {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                timeZone: 'UTC',
            });
        };

        return (
            <React.Fragment>
                <span className="left-header">DATA</span>
                {formatDate(rowData.DATA)}
            </React.Fragment>
        );
    };

    const Loader: React.FC = ({ children }) => {
        const divRef: any = useRef<HTMLDivElement | null>(null);

        const [isVisible] = useIntersectionObserver({
            elementRef: divRef,
        });



        return (
            <div
                ref={divRef}
                style={{
                    minHeight: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {children}
            </div>
        )
    }

    const handleChangeCPFCNPJ = (e: InputMaskChangeParams) => {
        console.log("InputMaskChangeParams: ", e)
        console.log("InputMaskChangeParams: ", e.target)
        console.log("InputMaskChangeParams: ", e.target.value)
        console.log("InputMaskChangeParams: ", e.value)
        getFaturaListController.formik.setFieldValue('CPF_CNPJ', e.target.value);
    };


    return (
        <div>
            <Toast ref={getFaturaListController.toast} />
            <div className="p-card p-p-4 datatable-container">
                <Toolbar className="p-mb-4" left={leftFaturaToolbar}></Toolbar>

                <DataTable
                    header={tableHeader}
                    globalFilter={globalFilter} rowHover
                    className="responsive-table p-datatable-sm"
                    dataKey="ID" autoLayout scrollable scrollHeight={'100%'}
                    value={getFaturaListController.FaturasData}
                >
                    <Column field="NUMERO" header="NUMERO" body={HEADER_NUMERO}></Column>
                    <Column field="DESCRICAO" header="DESCRICAO" body={HEADER_DESCRICAO}></Column>
                    <Column field="NEGOCIO" header="NEGOCIO" body={HEADER_NEGOCIO}></Column>
                    <Column field="DATA" header="DATA" body={HEADER_DATA}></Column>
                    <Column field="ORGAOUNIDADE" header="UNIDADE" body={HEADER_ORGAOUNIDADE}></Column>
                    <Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
                </DataTable>

            </div>


            <Dialog
                className="p-fluid"
                style={{ width: '90%' }}
                visible={getFaturaListController.editDialog}
                onHide={handleFaturaListController.closeEditDialog}
                onShow={() => {
                    getFaturaListController.formik.setValues(getFaturaListController.selectedFatura);
                }}
                footer={editFaturaDialogFooter}
                header={`Editar negocio ${getFaturaListController.selectedFatura?.FT_CONTRATO.NUMERO}`}
                modal
            >
                {getFaturaListController.loadingEdit ? <LoadingScreen color="#0388e5" /> : <></>}
                <div className="p-grid p-fluid">
                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="cpf" >CPF / CNPJ</label>
                        <InputMask id="cpf" disabled
                            mask='99.999.999/9999-99'
                            {...getFaturaListController.formik.getFieldProps('CPF_CNPJ')}
                            onChange={handleChangeCPFCNPJ}>

                            {(inputProps: any) => (
                                <input
                                    {...inputProps}
                                    id="cpf"
                                    name="CPF_CNPJ"
                                    disabled={false}
                                />
                            )}

                        </InputMask>

                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getFaturaListController.formik.touched.FT_CONTRATO?.NUMERO && getFaturaListController.formik.errors.FT_CONTRATO?.NUMERO,
                            'popup-form-inactive': !(getFaturaListController.formik.touched.FT_CONTRATO?.NUMERO && getFaturaListController.formik.errors.FT_CONTRATO?.NUMERO),
                        })}
                        >{getFaturaListController.formik.errors.FT_CONTRATO?.NUMERO}</div>
                    </div>

                    <div className="p-field p-col-12 p-md-8">
                        <label htmlFor="nomeComp" >Nome completo</label>
                        <InputText id="nomeComp"
                            {...getFaturaListController.formik.getFieldProps('NOME')}
                            onChange={getFaturaListController.formik.handleChange('NOME')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getFaturaListController.formik.touched.FT_CONTRATO?.NUMERO && getFaturaListController.formik.errors.FT_CONTRATO?.NUMERO,
                            'popup-form-inactive': !(getFaturaListController.formik.touched.FT_CONTRATO?.NUMERO && getFaturaListController.formik.errors.FT_CONTRATO?.NUMERO),
                        })}
                        >{getFaturaListController.formik.errors.FT_CONTRATO?.NUMERO}</div>
                    </div>



                </div>
            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getFaturaListController.deleteDialog}
                onHide={handleFaturaListController.closeDeleteDialog}
                footer={deleteFaturaDialogFooter}
                header="Remover negocio"
                modal
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {getFaturaListController.selectedFatura && <span>Você tem certeza que deseja remover <b>{getFaturaListController.selectedFatura.FT_CONTRATO?.NUMERO}</b>?</span>}
                </div>
            </Dialog>
        </div>

    );
};

export default FaturasList;